'use client'

import { zodResolver } from '@hookform/resolvers/zod'
import {
  Control,
  FieldErrors,
  useForm,
  UseFormHandleSubmit,
  UseFormRegister,
} from 'react-hook-form'
import { loginSchema } from '../../_schema'
import { LoginFormValues } from '../../_schema/types'

interface UseLoginFormReturn {
  register: UseFormRegister<LoginFormValues>
  control: Control<LoginFormValues>
  errors: FieldErrors<LoginFormValues>
  handleSubmit: UseFormHandleSubmit<LoginFormValues>
}

export const useLoginForm = (
  defaultValues: LoginFormValues
): UseLoginFormReturn => {
  const form = useForm<LoginFormValues>({
    defaultValues,
    resolver: zodResolver(loginSchema),
  })

  return {
    register: form.register,
    control: form.control,
    errors: form.formState.errors,
    handleSubmit: form.handleSubmit,
  }
}
